import React, { useState, useRef } from "react";
import { Form } from "react-bootstrap";
import Button from "react-bootstrap/Button";
import { fireDb, fireStorage, timestamp } from "../Firebase/Config";
import Progress from "./Progress";

const File = () => {
  const inputRef = useRef();
  const [inputFile, setInputFile] = useState(null);
  const [progress, setProgress] = useState(0);
  const [error, setError] = useState(null);
  // const [url, setUrl] = useState(null);
  const [disable, setDisable] = useState(false);

  // get the file and set to inputFile State
  const handleInput = (e) => {
    let file = e.target.files[0];
    let size = file && (file.size / (1024 * 1024)).toFixed(2);
    if (file && size < 3) {
      setInputFile(file);
    } else {
      setInputFile(null);
      inputRef.current.value = "";
      alert("plz select file less than 3 Mb");
    }
  };

  // push  file to firebase

  const handleSubmit = (e) => {
    e.preventDefault();
    if (inputFile) {
      setDisable(true);

      // setting references to store
      const storageRef = fireStorage.ref(inputFile.name);
      const collectionRef = fireDb.collection("files");

      // upload file to storage and create matching data to firedatabase collection(file)

      storageRef.put(inputFile).on(
        "state_changed",
        (snap) => {
          let percentage = (snap.bytesTransferred / snap.totalBytes) * 100;
          setProgress(percentage);
        },
        (err) => {
          setError(err);
        },
        async () => {
          const url = await storageRef.getDownloadURL();
          const createdAt = timestamp();
          const date = new Date().toLocaleString();
          const name = inputFile.name;
          const fileSize = (inputFile.size / (1024 * 1024)).toFixed(2);
          const type = inputFile.type;
          await collectionRef.add({
            url,
            createdAt,
            name,
            fileSize,
            type,
            date,
          });
          // setUrl(url);
          alert("File upload success !");
          setInputFile(null);
          inputRef.current.value = "";
          setProgress(0);
          setDisable(false);
        }
      );
    } else {
      alert("plz select  proper file ");
    }
  };

  return (
    <Form className="form" onSubmit={handleSubmit}>
      {error && <div className="err">{error}</div>}
      <Form.Group controlId="formFile" className="mb-3">
        <Progress progress={progress} />
      </Form.Group>
      <Form.Group controlId="formFile" className="mb-3">
        <Form.Control
          type="file"
          onChange={handleInput}
          ref={inputRef}
          disabled={disable}
        />
      </Form.Group>
      <Form.Group controlId="formFile" className="mb-3">
        <Button variant="success" type="submit" disabled={disable}>
          {` ${disable ? " Uploading..." : "Upload"}`}
        </Button>
      </Form.Group>
    </Form>
  );
};

export default File;
